import getOppositePlacement from './getOppositePlacement.js';
import getOppositeVariationPlacement from './getOppositeVariationPlacement.js';
import getAlteredPosition from './getAlteredPosition.js';
import type { DSHookFloatingContextT } from '../react-desc-prop-types.js';

const hash = {
  left: 'bottom-start',
  right: 'top-start',
  bottom: 'top-start',
  top: 'bottom-start',
} as const;

function getAuxPlacement(placement: string) {
  return placement.replace(/left|right|bottom|top/g, (matched: string) => hash[matched as keyof typeof hash]);
}

export const getExpandedFallbackPlacements = (placement: DSHookFloatingContextT.PopperPlacementsT) => {
  const oppositePlacement = getOppositePlacement(placement);
  return [
    oppositePlacement,
    getOppositeVariationPlacement(placement),
    getAlteredPosition(placement),
    getOppositePlacement(getAlteredPosition(placement)),
    getAuxPlacement(placement),
    getOppositePlacement(getAuxPlacement(placement)),
  ];
};
